import React from 'react';
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check } from 'lucide-react';

const Services = () => {
  const services = [
    {
      title: "Web Design & Development",
      description: "Custom websites built with modern technologies like React, Next.js, and Tailwind CSS.",
      features: ["Responsive Design", "SEO Optimization", "CMS Integration", "Performance Tuning"],
      price: "Starting at $2,500"
    },
    {
      title: "Brand Identity",
      description: "Complete branding packages to give your business a unique and memorable voice.",
      features: ["Logo Design", "Brand Guidelines", "Stationery Design", "Social Media Assets"],
      price: "Starting at $1,500"
    },
    {
      title: "Digital Marketing",
      description: "Data-driven marketing strategies to increase your reach and conversion rates.",
      features: ["Social Media Management", "PPC Campaigns", "Content Marketing", "Email Automation"],
      price: "Starting at $1,000/mo"
    },
    {
      title: "Mobile App Development",
      description: "Native and cross-platform mobile applications for iOS and Android.",
      features: ["React Native / Flutter", "UI/UX Design", "App Store Submission", "Maintenance"],
      price: "Custom Quote"
    }
  ];

  return (
    <div className="flex flex-col gap-20 pb-20 pt-10">
      <section className="container mx-auto px-4 md:px-6 text-center max-w-4xl">
        <Badge className="mb-4 bg-accent/10 text-accent hover:bg-accent/20 border-none">Our Services</Badge>
        <h1 className="text-4xl md:text-6xl font-heading font-bold mb-6">
          Solutions Tailored to Your <span className="text-primary">Needs</span>
        </h1>
        <p className="text-xl text-muted-foreground leading-relaxed">
          We offer a comprehensive range of digital services designed to help your business thrive in the digital age.
        </p>
      </section>

      <section className="container mx-auto px-4 md:px-6">
        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <Card key={index} className="flex flex-col hover:shadow-xl transition-shadow duration-300 border-border/60">
              <CardHeader>
                <CardTitle className="text-2xl font-bold">{service.title}</CardTitle>
                <CardDescription className="text-lg mt-2">{service.description}</CardDescription>
              </CardHeader>
              <CardContent className="flex-grow flex flex-col justify-between gap-6">
                <ul className="space-y-3">
                  {service.features.map((feature, i) => (
                    <li key={i} className="flex items-center gap-3">
                      <div className="w-6 h-6 rounded-full bg-green-100 text-green-600 flex items-center justify-center flex-shrink-0">
                        <Check className="h-3 w-3" />
                      </div>
                      <span className="text-muted-foreground">{feature}</span>
                    </li>
                  ))}
                </ul>
                <div className="pt-4 border-t border-border flex items-center justify-between">
                  <span className="font-bold text-lg text-primary">{service.price}</span>
                  <Button variant="outline">Learn More</Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Services;
